import { useLocation } from 'react-router-dom'

function QMSIcon({ size = 28 }) {
    const location = useLocation()
    const isActive = location.pathname.startsWith('/qms')
    const color = isActive ? '#FFFFFF' : '#8F9DAC'

    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 28 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M17.5 2.9165V4.6665C17.5 6.31642 17.5 7.14138 18.0125 7.65394C18.5251 8.1665 19.3501 8.1665 21 8.1665H22.75"
                stroke={color}
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M4.66669 18.6668V9.3335C4.66669 6.03366 4.66669 4.38375 5.69181 3.35862C6.71694 2.3335 8.36685 2.3335 11.6667 2.3335H16.5336C17.0104 2.3335 17.2488 2.3335 17.4633 2.4223C17.6776 2.51111 17.8463 2.67972 18.1835 3.01692L22.6499 7.48341C22.9871 7.82061 23.1558 7.98922 23.2446 8.20361C23.3334 8.41801 23.3334 8.65646 23.3334 9.13333V18.6668C23.3334 21.9666 23.3334 23.6165 22.3082 24.6417C21.2831 25.6668 19.6332 25.6668 16.3334 25.6668H11.6667C8.36685 25.6668 6.71694 25.6668 5.69181 24.6417C4.66669 23.6165 4.66669 21.9666 4.66669 18.6668Z"
                stroke={color}
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9.33331 12.8335H18.6666M9.33331 16.3335H18.6666M9.33331 19.8335H14.1992"
                stroke={color}
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export default QMSIcon
